import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import injectSheet, { withTheme } from 'react-jss'
import flow from 'lodash/flow'
import {getScreenBreakpoint} from "../../selectors"
import theme from "../../styles/theme"
import HeroCard from '../Card/ArticleHeroFeatureCard'
import Section from '../Widgets/Section'

class HeroFeature extends PureComponent {

  render() {
    const { classes, page, slice, theme, is_mobile } = this.props;
    const { featured_article, content_position, category_time, content_title, content_subtitle, video, video_mobile, image } = slice
    const color = page ? theme.getLandingPageColor(page.landing_page_uid) : undefined
    let new_article = content_title ? {...featured_article, title: content_title, summary: content_subtitle && `<p>${content_subtitle}</p>`} : featured_article
    let new_video = video ? video : featured_article.video;
    let new_image = image ? image : featured_article.horizontal_hero;

    return (
      <Section className={classes.root}>
        <HeroCard
          article={new_article}
          images={new_image}
          showArticleMeta={category_time === "Hide" ? false : true}
          showSummary
          color={color}
          contentPosition={content_position}
          video={new_video}
          video_mobile={video_mobile}
          isMobile={is_mobile}
        />
      </Section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    is_mobile: getScreenBreakpoint(state) === theme.breakpoints.mobile ? true : false
  }
}

export default flow([
  injectSheet((theme) => ({
    root: {
      marginTop: theme.spacing.normal
    }
  })),
  withTheme
])( connect(mapStateToProps)(HeroFeature) );



// WEBPACK FOOTER //
// ./src/components/LandingPage/HeroFeature.js